// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { appLinks } from "src/assets/config/constants";

// WARNING - Values under "firebase" and value of "googleApiKey" needs to be replaced from your own accounts
// If left as is, it firbase and google map related functionality will not work on LIVE instance.
export const environment = {
  production: false,
  orderSlaEnabled: false,
  inventoryAlertsEnabled: false,
  firebase: {
      apiKey: 'AIzaSyAvHtu5rrqKSZQg75R2MYqlNgGdMKy2YR4',
      projectId: 'modern-admin-8453e',
      authDomain: 'modern-admin-8453e.firebaseapp.com',
      appId: '1:300550201463:web:96a271cc309ac5aea86672'
    },
    googleApiKey: 'AIzaSyAIIYOxA7qeetFz6TuR1Qewc0Rrjhzx7ZU',
    // baseAPIHost : "https://1890-2401-4900-1c07-ddf5-2dd4-68c1-f244-31ab.ngrok-free.app",
    baseAPIHost: "https://dev-api.gayatrimandapa.in",
    // baseAPIHost: "https://pooja-dev-api-941134009078.us-central1.run.app",
    // baseAPIHost: "https://7bf1-2405-201-27-10ac-18b4-1514-af82-4450.ngrok-free.app",
    // Image upload
      ...appLinks,
    
  
  };
